<template>
  <v-navigation-drawer
    v-model="formShow"
    clipped
    right
    fixed
    width="30rem"
    style="top: 64px"
    stateless
  >
    <v-form
      ref="form"
      lazy-validation
      class="d-flex flex-column"
      style="height: calc(100% - 64px)"
    >
      <v-toolbar flat dark color="primary">
        <v-btn icon @click="handleBack">
          <v-icon>mdi-arrow-left</v-icon>
        </v-btn>
        <v-list-item>
          <v-list-item-title>เพิ่ม Device ในกลุ่ม</v-list-item-title>
        </v-list-item>
      </v-toolbar>
      <div class="pt-2 px-4" style="height: 100%; overflow: auto">
        <v-row>
          <v-col cols="12" lg="6">
            <label class="caption">ค้นหา</label>
            <v-text-field
              v-model="search"
              class="fix-google-chrome"
              prepend-inner-icon="mdi-magnify"
              outlined
              dense
              clearable
              @input="handleSearchHardware"
              hide-details
            >
            </v-text-field
          ></v-col>
          <v-col cols="12" lg="6">
            <label class="caption">รุ่นของ Device</label>
            <v-autocomplete
              v-model="hardwareModelFilter"
              class="fix-google-chrome"
              :items="hardwareModels"
              item-text="title"
              item-value="hardware_model_code"
              hide-details
              outlined
              dense
              clearable
              @change="handleFilterHardwareModel"
            >
            </v-autocomplete
          ></v-col>
        </v-row>
        <v-row class="mt-6 mb-2">
          <v-col class="pb-0" cols="6">
            <div class="ml-4 d-inline-flex align-center">
              <input
                :disabled="pagination.isLoading || !hardwaresGroupMember.length"
                :indeterminate.prop="indeterminateSelectAll"
                id="selectAll"
                style="width: 18px; height: 18px"
                type="checkbox"
                :checked="checkedSelectAll"
                @input="handleSelectAll"
              />
              <label for="selectAll" class="ml-4" style="font-size: 14px">
                เลือกทั้งหมด
              </label>
            </div>
          </v-col>
          <v-col class="py-0" cols="6">
            <v-select
              class="pt-0"
              style="font-size: 14px"
              v-model="sort"
              :disabled="pagination.isLoading"
              prepend-inner-icon="mdi-sort-ascending"
              :items="sorts"
              hide-details
              @change="handleChangeSort"
            >
            </v-select
          ></v-col>
        </v-row>
        <DynamicScroller
          :items="hardwaresGroupMember"
          :min-item-size="pagination.limit"
          key-field="hardware_uuid"
        >
          <template v-slot="{ item, index, active }">
            <DynamicScrollerItem
              :item="item"
              :active="active"
              :data-index="index"
            >
              <div class="py-1">
                <v-card
                  color="#f5f5f5"
                  outlined
                  class="d-flex align-center"
                  v-observe-visibility="
                    item.hardware_uuid === lastHardware.hardware_uuid &&
                    !isLastPage
                      ? infiniteScrollHandler
                      : false
                  "
                >
                  <span class="pa-4">
                    <input
                      :id="item.hardware_uuid"
                      :value="item.hardware_uuid"
                      v-model="hardwaresSelected"
                      style="width: 18px; height: 18px"
                      type="checkbox"
                    />
                  </span>
                  <v-list-item two-line class="px-0">
                    <v-list-item-content>
                      <v-list-item-title>
                        {{ item.hardware_code }} - {{ item.title_th }}
                      </v-list-item-title>
                      <v-list-item-subtitle>
                        รุ่น : {{ item.hardware_model.title }}
                      </v-list-item-subtitle>
                    </v-list-item-content>
                  </v-list-item>
                </v-card>
              </div>
            </DynamicScrollerItem>
          </template>
        </DynamicScroller>
        <div v-if="pagination.isLoading">
          <div class="py-1">
            <v-card
              color="#f5f5f5"
              v-for="num in 2"
              :key="num"
              outlined
              class="px-4 py-2"
            >
              <Skeleton width="200px" />
              <Skeleton :count="1" />
            </v-card>
          </div>
        </div>
      </div>
      <v-toolbar flat color="blue-grey lighten-4">
        <v-row justify="center" align="center">
          <v-btn
            class="primary mr-3 text-capitalize"
            :disabled="!isHardwareGroupAddDataChange"
            depressed
            @click="onSubmit"
          >
            เพิ่ม Device
          </v-btn>
          <v-btn depressed @click="handleCancel"> ยกเลิก </v-btn>
        </v-row>
      </v-toolbar>
    </v-form>
    <ConfirmDialog
      :dialog="confirmDialogDataChange"
      :loading="confirmDialogDataChangeLoading"
      :dialogData="confirmDialogDataChangeData"
      @cancelConfirmDialog="cancelConfirmDialogDataChange"
      @submitConfirmDialog="submitConfirmDialogDataChange"
    />
  </v-navigation-drawer>
</template>

<script>
import _ from 'lodash'
import { Skeleton } from 'vue-loading-skeleton'
import { DynamicScroller, DynamicScrollerItem } from 'vue-virtual-scroller'
import 'vue-virtual-scroller/dist/vue-virtual-scroller.css'
import { mapActions } from 'vuex'

// @ is an alias to /src
import ConfirmDialog from '@/components/ConfirmDialog.vue'

export default {
  components: {
    ConfirmDialog,
    DynamicScroller,
    DynamicScrollerItem,
    Skeleton,
  },
  props: {
    formShow: {
      type: Boolean,
      default: false,
    },
    hardwareGroup: {
      type: Object,
    },
    hardwareGroupInit: {
      type: Object,
    },
  },
  watch: {
    formShow(value) {
      if (value) {
        this.hardwaresGroupMember = []
        this.pagination.currentPage = 1
        this.totalHardwaresGroupMember = 0
        this.getHardwaresGroupMember()
      }
    },
  },
  data() {
    return {
      hardwaresSelected: [],
      hardwareModelFilter: '',
      search: '',
      pagination: {
        currentPage: 1,
        limit: 10,
        isLoading: true,
      },
      hardwaresGroupMember: [],
      totalHardwaresGroupMember: 0,
      sort: 'hardware_code,asc',
      sorts: [
        { id: 1, text: 'เรียงตามรหัส', value: 'hardware_code,asc' },
        { id: 2, text: 'เรียงตามชื่อ (a - z)', value: 'title_th,asc' },
      ],
      confirmDialogDataChange: false,
      confirmDialogDataChangeLoading: false,
      confirmDialogDataChangeData: {},
    }
  },
  computed: {
    checkedSelectAll() {
      return (
        this.hardwaresSelected.length &&
        this.hardwaresSelected.length === this.totalHardwaresGroupMember
      )
    },
    indeterminateSelectAll() {
      return (
        this.hardwaresSelected.length &&
        this.hardwaresSelected.length !== this.totalHardwaresGroupMember
      )
    },
    lastHardware() {
      const [lastItem] = this.hardwaresGroupMember.slice(-1)
      return lastItem || {}
    },
    isLastPage() {
      return (
        this.pagination.currentPage ===
        Math.ceil(this.totalHardwaresGroupMember / this.pagination.limit)
      )
    },
    hardwareModels() {
      return this.$store.state.hardware.hardwareModels.filter((h) =>
        [
          'acu81',
          'tat51i',
          'cru77rf',
          'q3rac',
          'vf600',
          'vf1000',
          'vf1000r',
          'acu01r',
          'cru67rc',
          'cru67rf',
        ].includes(h.hardware_model_code)
      )
    },
    isHardwareGroupAddDataChange() {
      if (this.hardwaresSelected.length) {
        this.$emit('isHardwareGroupAddDataChange', true)
        return true
      }
      this.$emit('isHardwareGroupAddDataChange', false)
      return false
    },
  },
  methods: {
    ...mapActions({
      fetchHardwaresGroupMember: 'hardwaresGroup/fetchHardwaresGroupMember',
      addHardwareGroupMember: 'hardwaresGroup/addHardwareGroupMember',
      fetchHardwareGroupById: 'hardwaresGroup/fetchHardwareGroupById',
    }),
    async handleSelectAll(event) {
      try {
        const isChecked = event.target.checked
        if (isChecked) {
          if (
            this.totalHardwaresGroupMember === this.hardwaresGroupMember.length
          ) {
            this.hardwaresSelected = this.hardwaresGroupMember.map(
              (e) => e.hardware_uuid
            )
          } else {
            this.$store.state.loading = true

            const { company_uuid } = this.$store.state.authentication.company

            const payload = {
              company_uuid,
              hardware_group_uuid: this.hardwareGroup.hardware_group_uuid,
              params: {
                dpc: 'access-hardware-group-post-delete-to-list-access-hardware-group',
                hardware_model_code: this.hardwareModelFilter || undefined,
                search: this.search || undefined,
                sort: this.sort,
                is_outside_group: true,
              },
            }

            const { data: hardwaresGroupMember } =
              await this.fetchHardwaresGroupMember(payload)
            this.hardwaresSelected = hardwaresGroupMember.map(
              (e) => e.hardware_uuid
            )
            this.$store.state.loading = false
          }
        } else {
          this.hardwaresSelected = []
        }
      } catch (error) {
        this.$store.state.loading = false

        const snackbar = {
          show: true,
          color: 'error',
          timeout: -1,
          message: error?.response?.data?.message || 'Something went wrong!',
        }
        this.$store.commit('SET_SNACKBAR', snackbar)
      }
    },
    handleFilterHardwareModel() {
      this.hardwaresSelected = []
      this.hardwaresGroupMember = []
      this.pagination.currentPage = 1
      this.getHardwaresGroupMember()
    },
    handleSearchHardware: _.debounce(function () {
      if (this.search === undefined || this.search === null) return
      this.hardwaresSelected = []
      this.hardwaresGroupMember = []
      this.pagination.currentPage = 1
      this.getHardwaresGroupMember()
    }, 1000),
    handleChangeSort() {
      this.hardwaresSelected = []
      this.hardwaresGroupMember = []
      this.pagination.currentPage = 1
      this.getHardwaresGroupMember()
    },
    async getHardwaresGroupMember() {
      try {
        this.pagination.isLoading = true

        const { company_uuid } = this.$store.state.authentication.company

        const payload = {
          company_uuid,
          hardware_group_uuid: this.hardwareGroup.hardware_group_uuid,
          params: {
            dpc: 'access-hardware-group-post-delete-to-list-access-hardware-group',
            hardware_model_code: this.hardwareModelFilter || undefined,
            search: this.search || undefined,
            sort: this.sort,
            limit: `${this.pagination.limit},${
              (this.pagination.currentPage - 1) * this.pagination.limit
            }`,
            is_outside_group: true,
          },
        }
        const { total: totalHardwaresGroupMember, data: hardwaresGroupMember } =
          await this.fetchHardwaresGroupMember(payload)
        this.totalHardwaresGroupMember = totalHardwaresGroupMember
        this.setHardwaresGroupMember(hardwaresGroupMember)
        this.pagination.isLoading = false
      } catch (error) {
        this.pagination.isLoading = false

        const snackbar = {
          show: true,
          color: 'error',
          timeout: -1,
          message: error?.response?.data?.message || 'Something went wrong!',
        }
        this.$store.commit('SET_SNACKBAR', snackbar)
      }
    },
    async getNextHardwaresGroupMember() {
      try {
        this.pagination.currentPage += 1

        await this.getHardwaresGroupMember()
      } catch (error) {
        const snackbar = {
          show: true,
          color: 'error',
          timeout: -1,
          message: error?.response?.data?.message || 'Something went wrong!',
        }
        this.$store.commit('SET_SNACKBAR', snackbar)
      }
    },
    setHardwaresGroupMember(hardwaresGroupMember) {
      this.hardwaresGroupMember = [
        ...this.hardwaresGroupMember,
        ...hardwaresGroupMember,
      ]
    },
    infiniteScrollHandler(isVisible, entry) {
      if (isVisible && entry.isIntersecting) {
        this.getNextHardwaresGroupMember()
      }
    },
    async onSubmit() {
      try {
        const { company_uuid } = this.$store.state.authentication.company

        this.$store.state.loading = true

        this.search = ''

        const hardware_group_uuid = this.hardwareGroup.hardware_group_uuid

        const payload = {
          company_uuid,
          hardware_group_uuid,
          body: {
            hardware_uuids: this.hardwaresSelected,
          },
          params: {
            dpc: 'access-hardware-group-post-delete-to-list-access-hardware-group',
          },
        }

        await this.addHardwareGroupMember(payload)
        const hardwareGroup = await this.fetchHardwareGroupById({
          company_uuid,
          hardware_group_uuid,
        })
        this.$store.commit('hardwaresGroup/EDIT_HARDWARE_GROUP', hardwareGroup)
        this.hardwaresSelected = []
        this.$emit('addHardwareGroupMemberSuccess', hardwareGroup)
        this.$store.state.loading = false

        const snackbar = {
          show: true,
          color: 'success',
          timeout: 2000,
          message: 'เพิ่มข้อมูลสำเร็จ',
        }

        this.$store.commit('SET_SNACKBAR', snackbar)
      } catch (error) {
        this.$store.state.loading = false

        const snackbar = {
          show: true,
          color: 'error',
          timeout: -1,
          message: error?.response?.data?.message || 'Something went wrong!',
        }
        this.$store.commit('SET_SNACKBAR', snackbar)
      }
    },
    handleCancel() {
      this.hardwaresSelected = []
      this.$emit('onClickBlack')
    },
    handleBack() {
      if (this.isHardwareGroupAddDataChange) {
        this.confirmDialogDataChangeData = {
          title: 'ต้องการปิดใช่ไหม',
          text: 'คุณยังไม่ได้บันทึกข้อมูลของคุณ คุณแน่ใจหรือไม่ว่าต้องการปิดโดยที่ยังไม่บันทึกข้อมูล',
          value: '',
        }
        this.confirmDialogDataChange = true
      } else {
        this.$emit('onClickBlack')
      }
    },
    cancelConfirmDialogDataChange() {
      this.confirmDialogDataChange = false
    },
    submitConfirmDialogDataChange() {
      this.confirmDialogDataChange = false
      this.$emit('onClickBlack')
    },
  },
}
</script>
